export function getFileSize(bytes: number): string {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
}

export function getFileIcon(fileName: string): string {
  const extension = fileName.split('.').pop()?.toLowerCase();

  switch (extension) {
    case 'pdf':
      return 'picture_as_pdf';
    case 'doc':
    case 'docx':
      return 'description';
    case 'xls':
    case 'xlsx':
      return 'table_chart';
    case 'jpg':
    case 'jpeg':
    case 'png':
    case 'gif':
    case 'webp':
      return 'image';
    case 'mp4':
    case 'avi':
    case 'mov':
    case 'wmv':
      return 'videocam';
    case 'mp3':
    case 'wav':
    case 'ogg':
      return 'audiotrack';
    default:
      return 'insert_drive_file';
  }
}

export function getInvalidFiles(files: File[], accept: string) {
  if (!accept) return [];

  const acceptedTypes = accept.split(',').map((type) => type.trim().toLowerCase());

  return files.filter((file) => {
    const fileName = file.name.toLowerCase();
    const fileExtension = '.' + fileName.split('.').pop();
    const mimeType = file.type.toLowerCase();

    return !acceptedTypes.some((acceptedType) => {
      // Handle extension patterns (e.g. .pdf, .jpg)
      if (acceptedType.startsWith('.')) {
        return fileName.endsWith(acceptedType);
      }

      // Handle MIME type patterns (e.g. image/*, video/*)
      if (acceptedType.includes('*')) {
        const baseType = acceptedType.replace('*', '');
        return mimeType.startsWith(baseType);
      }

      // Handle specific MIME types (e.g. application/pdf)
      return mimeType === acceptedType;
    });
  });
}
